export default "__VITE_ASSET__Cy7D4sfl__"